import React, { useEffect, useState } from "react";
import "./YouTubeGallery.css";
import youtube from "../img/youtube.png"

const API_KEY = "AIzaSyBr1pPUSDpHLebS35GLSEb0FZFVAAu-xOA";
const CHANNEL_ID = "UCa5UWRmFQNDnE07oOqcS2Wg"; // Commence souvent par 'UC'

interface Video {
  id: string;
  title: string;
  thumbnail: string;
}

function YouTubeGallery() {
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUploads = async () => {
      try {
        // Étape 1 : obtenir l'ID de la playlist d'uploads
        const channelRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${CHANNEL_ID}&key=${API_KEY}`
        );
        const channelData = await channelRes.json();
        const uploadsPlaylistId =
          channelData.items[0].contentDetails.relatedPlaylists.uploads;

        // Étape 2 : récupérer les vidéos de cette playlist
        const playlistRes = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsPlaylistId}&maxResults=12&key=${API_KEY}`
        );
        const playlistData = await playlistRes.json();

        const formattedVideos = playlistData.items.map((item: any) => ({
          id: item.snippet.resourceId.videoId,
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.medium.url,
        }));

        setVideos(formattedVideos);
        setLoading(false);
      } catch (error) {
        console.error("Erreur lors du chargement des vidéos YouTube", error);
        setLoading(false);
      }
    };

    fetchUploads();
  }, []);

  return (
    <div className="youtube-gallery">
      <div className="video-card">
        <a
          href={`https://www.youtube.com/channel/UCa5UWRmFQNDnE07oOqcS2Wg`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={youtube} alt={"Ma chaine"} style={{height:"140px",objectFit:"contain"}} />
          <p>Ma chaine YouTube</p>
        </a>
      </div>
      {loading ? (
        <p>Chargement des vidéos...</p>
      ) : (
        videos.map((video) => (
          <div key={video.id} className="video-card">
            <a
              href={`https://www.youtube.com/watch?v=${video.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={video.thumbnail} alt={video.title} />
              <p>{video.title}</p>
            </a>
          </div>
        ))
      )}
    </div>
  );
}

export default YouTubeGallery;
